import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { ThemeProvider, styled } from '@mui/material/styles';
import { stipsSelectTheme } from '@/app/styles/muiTheme';

const StyledFormControl = styled(FormControl)(() => ({
  marginBottom: '1.3rem',
  width: '100%',
  '@media (max-device-width:599px)': {
    marginBottom: '0.4rem',
  },
}));

const StyledInputLabel = styled(InputLabel)(() => ({
  fontSize: '1.4rem',
  color: '#7c7e7e',

  '@media (max-width:599px)': {
    fontSize: '0.7rem',
    paddingTop: 20,
  },

  '@media (min-width:600px) and (max-width:780px)': {
    fontSize: '1rem',
    paddingTop: 20,
  },
}));

const StyledSelect = styled(Select)(() => ({
  fontSize: 12,
  fontWeight: 400,
  fontFamily: 'Open Sans',
  lineHeight: '1.5rem',
  backgroundColor: '#f4f6f8',
  border: '1px solid #f4f6f8',
  borderBottom: '1px solid #a7a9aa',
  borderRadius: '4px 4px 0px 0px',
  '@media (max-width:599px)': {
    fontSize: '0.6rem',
    paddingTop: '12px',
  },

  '@media (min-width:600px) and (max-width:780px)': {
    fontSize: '1rem',
    paddingTop: 40,
  },
}));

const StyledMenuItem = styled(MenuItem)(() => ({
  fontSize: '1rem',

  '@media (max-width:599px)': {
    fontSize: '0.5rem',
  },

  '@media (min-width:600px) and (max-width:780px)': {
    fontSize: '1rem',
  },
}));

export interface StipType {
  stipTypeId: number | string;
  stipTypeName: string;
}

interface StipsTypeSelectProps {
  selectValue: string | number | undefined;
  handleChange: (event: any) => void;
  stipsTypes?: StipType[];
  title: string;
  filledInputName: string;
  htmlFor: string;
}

const StipsTypeSelect = ({ selectValue, handleChange, stipsTypes, title, filledInputName, htmlFor }: StipsTypeSelectProps) => {
  return (
    <ThemeProvider theme={stipsSelectTheme}>
      <StyledFormControl variant="filled">
        <StyledInputLabel htmlFor={htmlFor}>{title}</StyledInputLabel>

        <StyledSelect
          value={selectValue}
          onChange={handleChange}
          input={
            <FilledInput
              name={filledInputName}
              id={htmlFor}
            />
          }
        >
          {stipsTypes?.map((type) => (
            <StyledMenuItem
              key={type.stipTypeId}
              value={type.stipTypeId}
            >
              {type.stipTypeName}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </ThemeProvider>
  );
};

export default StipsTypeSelect;
